<template>
  <div class="form-floating disabled-field" :class="'mb-'+mb">
    <div class="form-control form-control-solid">
      {{value}}
    </div>
    <label :class="{ required: required }">{{placeholder}}</label>
  </div>
</template>

<script>
export default {
  name: 'DisabledField',
  props: {
    mb: null,
    value: null,
    required: false,
    placeholder: null,
  }
}
</script>

<style scoped>

</style>